import styled from 'styled-components';
var Tag = styled.div.withConfig({
  displayName: "FabricTagstyles__Tag",
  componentId: "sc-1hyc2o0-0"
})(["border:1px solid ", ";color:", ";line-height:", ";margin:0 10px 0 0;padding:0 8px;border-radius:2px;"], function (props) {
  return props.theme.color.palette['green-50'];
}, function (props) {
  return props.theme.color.palette['green-50'];
}, function (props) {
  return props.theme.font['line-height']['label-1'];
});
export { Tag };